import(/* webpackMode: "eager", webpackExports: ["GpcSignal"] */ "/vercel/path0/apps/web/src/components/gpc-signal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/vercel/path0/apps/web/src/components/mobile-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogIdentify"] */ "/vercel/path0/apps/web/src/components/posthog-identify.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
